<template>
  <div>
    <div class="search">
      <i class="el-icon-search"></i>
      <input type="text" placeholder="搜尋承攬商名稱" v-model="searchKey" />
    </div>
    <div class="table_outter_block" ref="table_outter" >
      <template v-if="data.length!==0">
      <Table :column="thead" 
        :fixedColumn="fixedColumn" 
        :data="listData" 
        :type="type" 
        :tableHeight="tableHeight" 
        :pageHeight="pageHeight" 
        @sort="sort"></Table>
      <el-pagination
        :page-size="page.size"
        :pager-count="11"
        layout="prev, pager, next"
        :total="page.allPage"
        @current-change="pageChange"
      ></el-pagination>
      </template>
      <template  v-else-if="this.$store.state.loading==false">
                <div class="no_data" >
            <i class="el-icon-warning-outline"></i>
            <p>NO Data</p>
          </div>
      </template>

    </div>
  </div>
</template>
<style lang="scss">
.search {
  // background: #fff;
  width: fit-content;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0 10px;
  input {
    // border: none;
    background: transparent;
    border: none;
  }
  &:focus-within {
    border: 1px solid var(--mainColor);
  }
}
</style>

<script>
import Table from "@/components/Table.vue";
export default {
  name: "contractorList",
  data() {
    return {
      data: [],
      type: "admin-contractor",
      tableHeight: null,
      pageHeight: 50,
      thead: [
        {
          name: "操作",
          width: "60px",
          val: "action",
          align: "center"
        },
        {
          name: "審核",
          width: "60px",
          val: "is_pass",
          align: "center"
        },
        {
          name: "承攬商名稱",
          width: "340px",
          val: "vendor_chinese",
          align: "left"
        },
        {
          name:"需求單位",
          width: "250px",
          val:"department",
          align: "left"
        },
        {
          name: "統一編號",
          val: "tax_id",
          width: "150px",
          align: "left"
        },
        {
          name: "聯絡人",
          width: "100px",
          val: "contact_person",
          align: "left"
        },
        {
          name: "電話",
          width: "130px",
          val: "phone",
          align: "left"
        }
      ],
      fixedColumn: ["is_pass", "action", "vendor_chinese"],
      page: {
        size: 7,
        page: 1,
        allPage: null
      },
      searchKey: null,
      sortAttr: null
    };
  },
  components: {
    Table
  },
  computed: {
    paginationData() {
      if (this.sortAttr == null) {
        return this.data;
      } else if (this.sortAttr.includes("sort")) {
        //正排
        const item = this.sortAttr.split("_sort")[0];
        return this.data.sort((a, b) => {
          //另外處理字串的排序
          // if (typeof a[item] == "string") {
          //   //如果是字串的數字
          //   if (a[item].match(/^[0-9]*$/)) {
          //     return a[item] - b[item];
          //   } else {
          //     //如果A大於B，則回傳1，由小到大
          //     //如果A小於B，則回傳-1，由大到小
          //     return a[item] > b[item] ? 1 : -1;
          //   }
          // }else if(a[item]==null){
          //   return a[item] > b[item] ? 1 : -1;
          // }
          // else {
            return a[item] > b[item] ? 1 : -1;
          // }
        });
      } else {
        //逆排
        const item = this.sortAttr;
        return this.data.sort((a, b) => {
          // if (typeof a[item] == "string") {
          //   if (a[item].match(/^[0-9]*$/)) {
          //     return b[item] - a[item];
          //   } else {
          //     return a[item] < b[item] ? 1 : -1;
          //   }
          // } else {
            return a[item] < b[item] ? 1 : -1;
          // }
        });
      }
    },
    listData(){
      const list = [];
      this.page.allPage = this.data.length;
      for (
        let i = this.page.size * (this.page.page - 1);
        i < this.page.page * this.page.size;
        i++
      ) {
        if (this.paginationData[i]) {
          list.push(this.paginationData[i]);
        }
      }
      return list;
    }
  },
  methods: {
    getData(name) {
      this.$store.commit("loadingAction", true);
      this.$http.api.admin.vendorList(name).then(res => {
        this.page.allPage = res.data.length;
        this.data = res.data;
        this.$store.commit("loadingAction", false);
      });
    },
    pageChange(val) {
      this.page.page = val;
    },
    sort(arrt) {
      this.sortAttr = arrt;
    }
  },
  watch: {
    searchKey(newVal, oldVal) {
      this.getData(newVal);
    }
  },
  mounted() {
    this.$store.commit("loadingAction", null);
    this.getData();
    this.$nextTick(() => {
      if (this.$refs.table_outter) {
        this.tableHeight =
          this.$refs.table_outter.offsetHeight - this.pageHeight;
      }
    });
  }
};
</script>